"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getProductDetailsUrl = void 0;
/**
 * Generates a url for an applicant to view their product details in the merchant portal, including optional query parameters. Returns null if no return token is provided.
 */
const getProductDetailsUrl = (baseUrl, returnToken, queryParams) => {
    if (!returnToken) {
        return null;
    }
    const url = new URL(`${baseUrl}/a/productDetails/${returnToken}`);
    if (queryParams) {
        for (const [key, value] of Object.entries(queryParams)) {
            url.searchParams.set(key, value);
        }
    }
    return url.toString();
};
exports.getProductDetailsUrl = getProductDetailsUrl;
